import { Component, OnInit, Input } from '@angular/core';
import { CardToken, CardTokenQuery, ProviderName } from '@fgb/core';
import { TopUpAddressConfig, topUpAddressConfigDefault } from '@fgb/portal-component-library/src/lib/shared/top-up-address';
import { RegexUS } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { Observable } from 'rxjs';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'fgbcl-card-token-list',
  templateUrl: './card-token-list.component.html',
  styleUrls: ['./card-token-list.component.scss'],
})
export class CardTokenListComponent implements OnInit {
  @Input() provider = ProviderName.Dummy;
  @Input() redirectUrl = '/payment';
  @Input() failureUrl = '/cardtoken/failure';
  @Input() regex = RegexUS;
  @Input() topUpAddressConfig: TopUpAddressConfig = topUpAddressConfigDefault;
  @Input() showCloseBtn: boolean = false;
  @Input() cardIssuerProvider: string = '';
  @Input() showExpiry: boolean = false;
  @Input() version: number = 1;

  defaultCardToken$: Observable<CardToken>;
  nonDefaultCardTokens$: Observable<CardToken[]>;

  customOptions: OwlOptions = {
    items: 1,
    loop: false,
    autoHeight: false,
    autoWidth: true,
    margin: 15,
    autoplay: false,
    autoplayTimeout: 10000,
    autoplaySpeed: 1500,
  };
  customOptions2: OwlOptions = {
    items: 3,
    loop: false,
    touchDrag: false,
    autoHeight: false,
    autoWidth: true,
    margin: 22,
    autoplay: false,
    autoplayTimeout: 10000,
    autoplaySpeed: 1500,
  };

  constructor(private cardTokenQuery: CardTokenQuery) {}

  ngOnInit() {
    this.defaultCardToken$ = this.cardTokenQuery.selectDefaultCard();
    this.nonDefaultCardTokens$ = this.cardTokenQuery.selectExceptDefaultCard();
  }
}
